import { frappeGet, frappeMethod, frappeList } from "./utils";
import type { User } from "./types/user";

export const users = {
  /**
   * Get the current logged-in user
   */
  current(): Promise<User> {
    return frappeMethod<string>("frappe.auth.get_logged_user").then(
      async (username: string) => {
        if (!username || username === "Guest") {
          throw new Error("No user logged in");
        }
        return frappeGet<User>("User", username);
      }
    );
  },

  /**
   * Get user roles for the current user
   */
  async roles(): Promise<string[]> {
    const roles = await frappeMethod<string[]>("frappe.get_roles");
    return Array.isArray(roles) ? roles : [];
  },

  /**
   * Get a user by name
   */
  detail(userName: string): Promise<User> {
    return frappeGet<User>("User", userName);
  },

  /**
   * List users with optional filters
   * Used for batched avatar fetching
   */
  list(params: {
    filters?: Record<string, any>;
    fields?: string[];
  }): Promise<User[]> {
    return frappeList<User>("User", params.filters, params.fields);
  },

  /**
   * Get full URL for user image
   * Converts relative path to full URL if needed
   */
  getImageUrl(imagePath: string | null | undefined): string | undefined {
    if (!imagePath) return undefined;
    
    // If already a full URL, return as-is
    if (imagePath.startsWith("http://") || imagePath.startsWith("https://")) {
      return imagePath;
    }
    
    // If starts with /, it's a site-relative path
    // We need to prepend the Frappe site URL
    // For now, return as-is and let Frappe client handle it
    // In production, you might want to use frappeClient.getFileUrl() or similar
    return imagePath.startsWith("/") ? imagePath : `/${imagePath}`;
  },
};

